import { DatePicker, LoadingButton } from "components/form";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { exportExcelApi } from "services/dashboard";
import { downloadFile, getStartAndEndDate } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";
import { getDownloadReport } from "../../report/downloadReport";

const DownloadStatement = ({ modalClose }) => {
  const { selectedSite } = useSelector((state) => (state?.selectedSite))
  const [searchData, setSearchData] = useState({
    statement: '',
    startDate: '',
    endDate: ''
  })
  const [loading, setLoading] = useState(false);
  // console.log('searchData', searchData)
  // ----------handle-radio-button---------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData({ [name]: value })
  };
  // ----------handle-date-button---------------
  const handleDateChange = (name, date) => {
    setSearchData((prev) => ({
      ...prev, [name]: date,
      statement: "",
    }));
  };
  useEffect(() => {
    getStartAndEndDate(+searchData?.statement, setSearchData)
  }, [searchData?.statement])

  return (
    <>
      <div className="download_statement transaction_details">
        <div className="has_child">
          <h4>Download Statement</h4>
          <div className="button_wrap">
            <button type="button" onClick={modalClose}>
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="date_list">
          <ul>
            {/* <li>
              <label>
                <span>Today</span>
                <input
                  // onChange={handleChange}
                  type="radio"
                  name="statement"
                  // value='30'
                  // checked={searchData.statement === "30"}
                  defaultChecked
                />
              </label>
            </li> */}
            <li>
              <label>
                <span>Last 30 Days</span>
                <input
                  onChange={handleChange}
                  type="radio"
                  name="statement"
                  value='30'
                  checked={searchData.statement === "30"}
                />
              </label>
            </li>
            <li>
              <label>
                <span>Last 60 Days</span>
                <input
                  onChange={handleChange}
                  type="radio"
                  name="statement"
                  value='60'
                  checked={searchData.statement === "60"}
                />
              </label>
            </li>
            <li>
              <label>
                <span>Last 180 Days</span>
                <input
                  onChange={handleChange}
                  type="radio"
                  name="statement"
                  value='180'
                  checked={searchData.statement === "180"}
                />
              </label>
            </li>
          </ul>
        </div>
        <div className="form_field">
          <label className="label">Search by Date Range</label>
          <div className="date_wrap">
            <div className="date">
              {" "}
              <DatePicker
                placeholder="start date"
                onChange={(date) => handleDateChange("startDate", date)}
                value={searchData?.startDate}
                maxDate={searchData?.endDate ? new Date(searchData.endDate) : new Date()} // Limit to today or endDate
              />
            </div>
            <div className="date">
              <DatePicker
                placeholder="End date"
                onChange={(date) => handleDateChange("endDate", date)}
                value={searchData?.endDate}
                minDate={searchData?.startDate ? new Date(searchData.startDate) : null}
                maxDate={new Date()} // Always limit to today
              />
            </div>
          </div>
        </div>
        <LoadingButton
          // onClick={() => exportBill(selectedSite, setLoading, searchData?.startDate, searchData?.endDate)}
          className="w-100"
          loading={loading}
        >
          Download
        </LoadingButton>
      </div>
    </>
  );
};

export default DownloadStatement;
